const API_BASE_URL: string =
  process.env.REACT_APP_API_BASE_URL || "https://app.pitchkraft.ai";
//process.env.REACT_APP_API_BASE_URL || "https://localhost:7216";

//
export default API_BASE_URL;

